import React, {useState, useEffect, useCallback} from 'react';
import {Field, Form} from 'react-final-form';
import t from 'babel-plugin-yate/macro';
import {useDispatch} from 'react-redux';
import {
  getTransactionSmsCode,
  postTransactionSmsCode,
} from '../../store/transaction';
import {
  composeFormValidators,
  isRequired,
  isAlphaNumeric,
} from '../../lib/validations';
import {formatWhiteSpaceFormField} from '../../lib/misc';
import ValidationError from '../../components/Form/ValidationError';
import {Input} from '../../components/Form/Input';
import Button from '../../components/Button';

let timerId;

function TransactionOtp(props) {
  const {transaction, handleAction} = props;
  const dispatch = useDispatch();
  const [disableGenerateBtn, setDisableGenerateBtn] = useState(false);
  const [isWaitingResponse, setIsWaitingResponse] = useState(false);
  const [codeValidationFailed, setCodeValidationFailed] = useState(null);
  const [codeGenerationFailed, setCodeGenerationFailed] = useState(null);
  const disableAll = transaction.status !== 'awaiting_otp';

  const handleGenerateOtp = useCallback(async () => {
    setDisableGenerateBtn(true);
    setCodeGenerationFailed(null);
    setIsWaitingResponse(true);
    const res = await dispatch(getTransactionSmsCode(transaction.uuid));
    setIsWaitingResponse(false);

    if (res.error) {
      setCodeGenerationFailed(res.errorMessage);
    }
  }, [dispatch, transaction.uuid]);

  const handleValidateOtp = useCallback(
    async ({code}) => {
      setCodeValidationFailed(null);
      setIsWaitingResponse(true);
      const res = await dispatch(
        postTransactionSmsCode(transaction.uuid, {code}),
      );
      setIsWaitingResponse(false);

      if (res.error) {
        setCodeValidationFailed(res.errorMessage);
        return;
      }

      handleAction();
    },
    [dispatch, transaction.uuid, handleAction],
  );

  useEffect(() => {
    if (disableGenerateBtn === false) {
      return;
    }

    clearInterval(timerId);
    timerId = setTimeout(() => {
      setDisableGenerateBtn(false);
    }, 120 * 1000);

    return () => clearTimeout(timerId);
  }, [disableGenerateBtn]);

  return (
    <Form
      keepDirtyOnReinitialize={true}
      onSubmit={handleValidateOtp}
      render={({values, handleSubmit}) => (
        <form onSubmit={handleSubmit}>
          <div className="md:flex w-full">
            <div className="mb-4 md:w-1/2">
              <Field
                name="mobile_phone"
                label={t`Mobile number`}
                component={Input}
                disabled={true}
                initialValue={transaction?.mobile_phone}
              />

              {codeGenerationFailed && (
                <ValidationError value={codeGenerationFailed} />
              )}

              <div
                className="pt-2"
                title={t`Puteti trimite un nou SMS peste 2 min`}>
                <Button
                  title={t`Genereaza cod (SMS)`}
                  customProps={{
                    type: 'button',
                    disabled:
                      isWaitingResponse || disableGenerateBtn || disableAll,
                  }}
                  onClick={handleGenerateOtp}
                  color="blue"
                  border={false}
                />
              </div>
            </div>

            <div className="md:pl-4 md:w-1/2">
              <Field
                autoComplete="one-time-code"
                label={t`Introduceti codul primit prin SMS`}
                name="code"
                component={Input}
                disabled={disableAll}
                format={formatWhiteSpaceFormField}
                validate={composeFormValidators(isRequired(), isAlphaNumeric())}
              />

              {codeValidationFailed && (
                <ValidationError value={codeValidationFailed} />
              )}

              <div className="pt-2">
                <Button
                  title={t`Validate`}
                  customProps={{
                    type: 'button',
                    disabled: !values.code || disableAll,
                  }}
                  onClick={() => handleValidateOtp(values)}
                  color="green"
                  border={false}
                />
              </div>
            </div>
          </div>
        </form>
      )}
    />
  );
}

export default TransactionOtp;
